import { useEffect, useState } from 'react';
import mediaService from '../services/whatsapp/mediaService';

/**
 * Resolves a stored R2 key into a presigned URL for display.
 *
 * Returns the already-attached `url` immediately when the server provided one
 * (outbound sends do), otherwise signs the key on demand.
 */
export const useMediaUrl = (
  r2Key: string | undefined,
  attachedUrl?: string
): { url: string | null; loading: boolean; failed: boolean } => {
  const [url, setUrl] = useState<string | null>(attachedUrl ?? null);
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (attachedUrl) {
      setUrl(attachedUrl);
      setFailed(false);
      return;
    }

    if (!r2Key) {
      setUrl(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setFailed(false);

    mediaService
      .resolve(r2Key)
      .then((resolved) => {
        if (cancelled) return;
        setUrl(resolved);
        setFailed(resolved === null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [r2Key, attachedUrl]);

  return { url, loading, failed };
};

export default useMediaUrl;
